<template>
  <div class="h-100 d-flex flex-column">
    <div class="d-flex justify-content-between mb-3 p-4 card-home-header">
      <h4 class="font-weight-normal mb-2 pt-1">
        {{ $t('home.blockAudience.title') }}
      </h4>
      <CButton class="px-4 py-2 font-weight-bold ctaInfoUserPrimary" @click="$router.push({ name: 'choose-methods' })">
        {{ $t('home.infoUser.addContact') }}
      </CButton>
    </div>

    <div v-if="this.$store.state.audience.hasAudience" class="h-100 d-flex flex-column">
      <span class="text-gray-400 w-100 d-block text-right font-italic font-weight-bold px-4 mb-3">
        {{ $t('home.infoUser.updated') }}: {{ audienceUpdatedOnFormatted }}
      </span>
      <div class="d-flex justify-content-between">
        <div class="card-home-audience-numbers d-flex justify-content-between align-items-center mx-3">
          <div class="card-home-audience-subtitle">{{ $t('home.infoUser.totalAudienceOfContacts') }}</div>
          <div class="card-home-audience-total">{{ audienceEvolution.totalContacts }}</div>
        </div>
        <div class="card-home-audience-numbers d-flex justify-content-between align-items-center mr-3">
          <div class="card-home-audience-subtitle">{{ $t('home.infoUser.recentlyUpdated') }}</div>
          <div class="card-home-audience-total">
            <span class="d-flex align-items-center">
              <CIcon :name="updatedAudienceIconName" class="text-success" size="custom-size" :height="24" viewBox="0 0 26 26" />
              {{ recentlyUpdatedMetric }}
            </span>
          </div>
        </div>
      </div>
      <CContainer v-if="isAudienceEvolutionChartProcessing" class="text-center d-flex align-items-center justify-content-center flex-grow-1">
        <CRow alignVertical="strech">
          <CCol>
            <div class="d-flex justify-content-center align-content-middle">
              <CIcon name="userBgFull" class="card-home-audience-icon mb-4" size="custom-size" :height="50" viewBox="0 0 32 32" />
            </div>
            <h5 class="font-weight-normal mb-3">
              {{ $t('home.blockAudience.title-processing-audience') }}
            </h5>
            <p class="text-gray-600">
              {{ $t('home.blockAudience.subtitle-processing-audience') }}
            </p>
          </CCol>
        </CRow>
      </CContainer>
      <AudienceChart v-else :dailyCount="audienceEvolution.dailyCount" />
    </div>

    <CContainer v-else class="text-center d-flex align-items-center justify-content-center flex-grow-1">
      <CRow alignVertical="strech">
        <CCol>
          <div class="d-flex justify-content-center align-content-middle">
            <CIcon name="userBgFull" class="card-home-audience-icon mb-4" size="custom-size" :height="50" viewBox="0 0 32 32" />
          </div>
          <h5 class="font-weight-normal mb-3">
            {{ $t('home.blockAudience.title-empty-audience') }}
          </h5>
          <p class="text-gray-600">
            {{ $t('home.blockAudience.subtitle-empty-audience') }}
          </p>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import { CButton } from '@coreui/vue'
import AudienceChart from './AudienceChart.vue'
import { dateFormatString } from '@/utils/dateUtil.js'
import { getUserDateFormat } from '@/utils/dateUtil.js'

export default {
  name: 'audienceBlock',
  components: { CButton, AudienceChart },
  props: {
    audienceEvolution: {
      type: Object,
      default: () => false,
    },
  },
  computed: {
    audienceUpdatedOnFormatted() {
      const lastUpdatedDateTime = this.audienceEvolution?.recentMetrics?.lastUpdateDateTime
      if (!lastUpdatedDateTime) return '-'

      const userDateTimeFormat = getUserDateFormat(this.$store.state.auth.user.dateTimeFormat)

      return dateFormatString(lastUpdatedDateTime, '', userDateTimeFormat)
    },
    updatedAudienceGrew() {
      if (!this.audienceEvolution?.recentMetrics) return true

      const recentMetrics = this.audienceEvolution.recentMetrics

      return recentMetrics.recentlyAdded > 0 ? true : false
    },
    updatedAudienceIconName() {
      return this.updatedAudienceGrew ? 'arrowUpGraph' : 'arrowDownGraph'
    },
    recentlyUpdatedMetric() {
      if (!this.audienceEvolution?.recentMetrics) return ''

      const recentMetrics = this.audienceEvolution.recentMetrics

      return recentMetrics.recentlyAdded || recentMetrics.recentlyDeleted
    },
    isAudienceEvolutionChartProcessing() {
      return this.audienceEvolution?.dailyCount?.length === 0
    },
  },
}
</script>

<style lang="scss" scoped>
.card-home-header {
  border-bottom: 1px solid #f1f3f5;
}

.card-home-audience-numbers {
  border: 1px solid #e9ecef;
  border-radius: 12px;
  min-width: 45%;
  height: 60px;
  padding: 20px;
}

.card-home-audience-total {
  color: #343a40;
  font-size: 24px;
  font-weight: 700;
}

.card-home-audience-subtitle {
  color: #868e96;
  font-size: 15px;
}

.card-home-audience-icon {
  color: #e8e0f0;
}
</style>
